module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-3-22b65e15856e631d1bc880727f1b9e3c.jpg";